import {
  BLUE,
  SALMON,
  GREEN,
  YELLOW,
  MINT,
  PINK,
  OCEAN_BLUE,
  PURPLE,
  CYAN,
  BLOODY,
  TEAL,
  AMBER,
  DARK_PURPLE,
  GOLD,
  LIGHT_BLUE,
  DEEP_ORANGE,
  INDIGO,
  BROWN,
  GREY,
} from "@/config/mui/colorPalette";

export const employeeColors = {
  "#797FD2": {
    color: BLUE,
    title: "Blue",
  },
  "#E47367": {
    color: SALMON,
    title: "Salmon",
  },
  "#94B7B3": {
    color: GREEN,
    title: "Green",
  },
  "#D7C155": {
    color: YELLOW,
    title: "Yellow",
  },
  "#54CBA3": {
    color: MINT,
    title: "Mint",
  },
  "#D14775": {
    color: PINK,
    title: "Pink",
  },
  "#4781D1": {
    color: OCEAN_BLUE,
    title: "Ocean Blue",
  },
  "#8659A6": {
    color: PURPLE,
    title: "Purple",
  },
  "#42BED7": {
    color: CYAN,
    title: "Cyan",
  },
  "#C64439": {
    color: BLOODY,
    title: "Bloody",
  },
  "#3D8F81": {
    color: TEAL,
    title: "Teal",
  },
  "#EE7C2B": {
    color: AMBER,
    title: "Amber",
  },
  "#7259C0": {
    color: DARK_PURPLE,
    title: "Dark Purple",
  },
  "#E6A119": {
    color: GOLD,
    title: "Gold",
  },
  "#476AD1": {
    color: LIGHT_BLUE,
    title: "Light Blue",
  },
  "#D2562C": {
    color: DEEP_ORANGE,
    title: "Deep Orange",
  },
  "#5959C0": {
    color: INDIGO,
    title: "Indigo",
  },
  "#6B5348": {
    color: BROWN,
    title: "Brown",
  },
  "#494950": {
    color: GREY,
    title: "Grey",
  },
};
